import { createFileRoute } from '@tanstack/react-router';

import { TOOL_GATES, ToolAccessGate } from 'shared/modules/capabilities';
import { LOCATION_DATA_UNAVAILABLE_PAGE } from 'shared/modules/country-support';

import { AiVisibility, aiVisibilitySearchSchema } from 'features/reports/ai-visibility/AiVisibility';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/ai-visibility/')({
  component: AiVisibilityRoute,
  validateSearch: aiVisibilitySearchSchema
});

function AiVisibilityRoute() {
  const { id } = Route.useParams();
  const { platform, promptType } = Route.useSearch();

  return (
    <ToolAccessGate gate={TOOL_GATES.AI_VISIBILITY} locationId={id} page={LOCATION_DATA_UNAVAILABLE_PAGE.AI_VISIBILITY}>
      <AiVisibility locationId={id} platformFilter={platform} promptTypeFilter={promptType} />
    </ToolAccessGate>
  );
}
